import { render } from "./TecnicosView.vue?vue&type=template&id=03408fb3"
import script from "./TecnicosView.vue?vue&type=script&lang=js"
export * from "./TecnicosView.vue?vue&type=script&lang=js"

import "./TecnicosView.vue?vue&type=style&index=0&id=03408fb3&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__